var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"global-loader"},[_c('moon-loader',{attrs:{"loading":_vm.preloader,"color":"var(--v-primary-base)"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }